import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Save } from 'lucide-react';

export default function CMSFooterSection({
  footerForm,
  setFooterForm,
  isSaving,
  onSave
}) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h3 className="font-bold text-slate-900 font-[Poppins] mb-6">Footer</h3>

      <div className="space-y-4">
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>Company Name</Label>
            <Input
              value={footerForm.company_name}
              onChange={(e) => setFooterForm(prev => ({ ...prev, company_name: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="footer-company"
            />
          </div>
          <div>
            <Label>Tagline</Label>
            <Input
              value={footerForm.tagline}
              onChange={(e) => setFooterForm(prev => ({ ...prev, tagline: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="footer-tagline"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          <div>
            <Label>Email</Label>
            <Input
              value={footerForm.email}
              onChange={(e) => setFooterForm(prev => ({ ...prev, email: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="footer-email"
            />
          </div>
          <div>
            <Label>Phone</Label>
            <Input
              value={footerForm.phone}
              onChange={(e) => setFooterForm(prev => ({ ...prev, phone: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="footer-phone"
            />
          </div>
          <div>
            <Label>Address</Label>
            <Input
              value={footerForm.address}
              onChange={(e) => setFooterForm(prev => ({ ...prev, address: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="footer-address"
            />
          </div>
        </div>

        <div>
          <Label className="mb-2 block">Social Media Links</Label>
          <div className="grid md:grid-cols-3 gap-4">
            <Input
              value={footerForm.social_links?.facebook || ''}
              onChange={(e) => setFooterForm(prev => ({ 
                ...prev, 
                social_links: { ...prev.social_links, facebook: e.target.value } 
              }))}
              placeholder="Facebook URL"
              className="h-10"
            />
            <Input
              value={footerForm.social_links?.twitter || ''}
              onChange={(e) => setFooterForm(prev => ({ 
                ...prev, 
                social_links: { ...prev.social_links, twitter: e.target.value } 
              }))}
              placeholder="Twitter URL"
              className="h-10"
            />
            <Input
              value={footerForm.social_links?.instagram || ''}
              onChange={(e) => setFooterForm(prev => ({ 
                ...prev, 
                social_links: { ...prev.social_links, instagram: e.target.value } 
              }))}
              placeholder="Instagram URL"
              className="h-10"
            />
          </div>
        </div>

        <div>
          <Label>Copyright Text</Label>
          <Input
            value={footerForm.copyright_text}
            onChange={(e) => setFooterForm(prev => ({ ...prev, copyright_text: e.target.value }))}
            className="h-12 mt-1.5"
            data-testid="footer-copyright"
          />
        </div>

        <Button 
          onClick={onSave}
          disabled={isSaving}
          className="bg-amber-500 hover:bg-amber-600 text-slate-900"
          data-testid="save-footer-btn"
        >
          <Save className="w-4 h-4 mr-2" />
          {isSaving ? 'Saving...' : 'Save Footer'}
        </Button>
      </div>
    </div>
  );
}
